<script setup lang="ts">
  import { useSanitizer } from '@/composables/useSanitizer'
  import type SlideFontSize from '@/enums/SlideFontSize'

  const { sanitize } = useSanitizer()
  
  const props = defineProps<{
    size: SlideFontSize
    heading: string
    isBackgroundColor?: boolean
  }>()
  
  const contentFromSlot = props.heading as string
  const sanitizedContent = sanitize(contentFromSlot)
</script>

<template>
  <h1 :class="['slide-heading', size, { 'with-background': isBackgroundColor }]">
    <span v-html="sanitizedContent" />
  </h1>
</template>

<style scoped lang="scss">
  .slide-heading {
    color: var(--color-pair-color);
    width: fit-content;
    margin: 0;
    font-weight: 600;
    z-index: 3;
  }

  .with-background {
    span {
      background-color: var(--color-pair-background-color);
      padding: 1rem;
      box-decoration-break: clone;
      -webkit-box-decoration-break: clone;
    }
  }

  .small {
    font-size: 5rem;
    line-height: 6.75rem;
  }

  .medium {
    font-size: 6.875rem;
    line-height: 9rem;
  }

  .large {
    font-size: 8.625rem;
    line-height: 10.25rem;
  }

  .extra-large {
    font-size: 13.75rem;
    line-height: 16.875rem;
  }
</style>
